import React from "react";
import { ErrorType } from "./errorType";

function ErrorMessage(props: ErrorType) {
  const { text,color } = props;
  return <p className={color?`errorMsgWhite`:`errorMsg`}>{text}</p>;
}

export default ErrorMessage;